module.exports = __webpack_public_path__ + "static/img/b2-2-2.3fd2ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b2-2-2.png
// module id = DEPC
// module chunks = 1